// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"61cc49d9","38":"e3552634","174":"6be04e31","239":"a18390c4","559":"129ded31"}[chunkId] + ".chunk.js";
};